module.exports = __webpack_public_path__ + "static/media/handmade-necklace_720x480.2d3f281b.jpg";